"use client";

import TermsContentTh from "./TermsContent.th";
import TermsContentEn from "./TermsContent.en";

export default function TermsContent({ lang = "th" }: { lang?: "th" | "en" }) {
  if (lang === "en") return <TermsContentEn />;
  return <TermsContentTh />;
}
